export const SAVE_SETTINGS = 'RASTER_SAVE_SETTINGS';
export const POLL_INTERVAL = 1000;

// Import dataset action types
export const CREATE = 'RASTER_CREATE';
export const SELECT_DATA_SOURCE = 'RASTER_SELECT_DATA_SOURCE';
export const UPDATE_UPLOAD_STATUS = 'RASTER_UPDATE_UPLOAD_STATUS';
export const DEFINE_DATA_SOURCE = 'RASTER_DEFINE_DATA_SOURCE';
export const DEFINE_RASTER_SETTINGS = 'RASTER_DEFINE_SETTINGS';
export const CLEAR_IMPORT = 'RASTER_CLEAR_IMPORT';

export const FETCH_RASTER_REQUEST = 'RASTER_FETCH_REQUEST';
export const FETCH_RASTER_SUCCESS = 'RASTER_FETCH_SUCCESS';
export const FETCH_RASTER_FAILURE = 'RASTER_FETCH_FAILURE';

export const IMPORT_RASTER_REQUEST = 'RASTER_IMPORT_REQUEST';
export const IMPORT_RASTER_PENDING = 'RASTER_IMPORT_PENDING';
export const IMPORT_RASTER_SUCCESS = 'RASTER_IMPORT_SUCCESS';
export const IMPORT_RASTER_FAILURE = 'RASTER_IMPORT_FAILURE';

export const FETCH_RASTERS_SUCCESS = 'RASTERS_FETCH_SUCCESS';

export const TOGGLE_RASTER_UPDATE_PENDING = 'RASTER_TOGGLE_UPDATE_PENDING';

// Delete raster
export const DELETE_RASTER_REQUEST = 'RASTER_DELETE_REQUEST';
export const DELETE_RASTER_FAILURE = 'RASTER_DELETE_FAILURE';
export const DELETE_RASTER_SUCCESS = 'RASTER_DELETE_SUCCESS';
export const REMOVE_RASTER = 'RASTER_REMOVE';



// WEBPACK FOOTER //
// ./src/constants/raster.js